import React from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ATMBreadCrumbs, {
  BreadcrumbType,
} from "src/components/UI/atoms/ATMBreadCrumbs/ATMBreadCrumbs";
import { getTabs } from "src/utils/auth/getTabs";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { TbBuildingBank } from "react-icons/tb";
import { LuFileSignature } from "react-icons/lu";
import { GiVillage } from "react-icons/gi";
import { CgNotes } from "react-icons/cg";

type Props = {};

const breadcrumbs: BreadcrumbType[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
  },
  {
    label: "Work History",
  },
];

const tabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName: string;
  type: "MODULE" | "ACTION" | "FIELD";
  accessAction: string;
}[] = [
    {
      label: "PAN",
      moduleName: "PAN_APPLICATIONS",
      accessAction: "WORK_HISTORY",
      type: "MODULE",
      icon: BsFillPersonVcardFill,
      path: "pan",
    },
    {
      label: "ITR",
      moduleName: "ITR_APPLICATIONS",
      type: "MODULE",
      accessAction: "WORK_HISTORY",
      icon: CgNotes,
      path: "itr",
    },
    {
      type: "MODULE",
      label: "Gumasta",
      moduleName: "GUMASTA_APPLICATIONS",
      accessAction: "WORK_HISTORY",
      icon: TbBuildingBank,
      path: "gumasta",
    },
    {
      label: "DSC",
      type: "MODULE",
      moduleName: "DSC_APPLICATIONS",
      icon: LuFileSignature,
      accessAction: "WORK_HISTORY",
      path: "dsc",
    },
    {
      label: "MSME",
      type: "MODULE",
      moduleName: "MSME_APPLICATIONS",
      accessAction: "WORK_HISTORY",
      icon: GiVillage,
      path: "msme",
    },
  ];

const WorkHistoryListing = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/")[2  ];

  return (
    <div className="flex flex-col gap-2 pt-3 h-full">
      {/* Breadcrumbs */}
      <div className=" px-4">
        <ATMBreadCrumbs breadcrumbs={breadcrumbs} />
      </div>
      <div className="flex flex-col gap-2 pt-3 grow overflow-auto">
        <div className="flex flex-col grow overflow-auto">
          {/* Tabs */}
          {tabs?.length && (
            <div className="flex gap-3 items-center  mx-4  border-b border-slate-400 bg-white ">
              {getTabs(tabs)?.map((tab, index) => {
                             return (
                  <button
                    key={index}
                    type="button"
                    onClick={() => navigate(tab.path)}
                    className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-sm transition-all
        ${currentPath === tab.path.split("/")[0]
                        ? "text-primary-main   border-primary-main"
                        : "text-gray-700 border-white"
                      }
         `}
                  >
                    <div className=" text-lg  ">
                      <tab.icon />
                    </div>
                    {tab.label}
                  </button>
                );
              })}
            </div>
          )}

          {/* Outlet */}
          <div className="grow overflow-auto ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkHistoryListing;
